import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { translations } from "../i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dk_lang") || "el");

  useEffect(() => {
    localStorage.setItem("dk_lang", lang);
    // Reflect language on <html lang="..."> so CSS :lang() / html[lang="..."]
    // selectors (e.g. disabling uppercase on Greek kickers) can target it.
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useMemo(() => {
    return (key) => {
      const parts = key.split(".");
      let node = translations[lang];
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return key;
      }
      return (typeof node === "string" || Array.isArray(node)) ? node : key;
    };
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
